module.exports = __webpack_public_path__ + "static/media/crabi-logo.1e6da8a8.svg";